













































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class JiluRender extends Vue {
  @Prop()
  private jilus: any;
}
